<div class="container">
  <mat-toolbar>
    <button mat-icon-button (click)="backToLogin()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>Login with MFA</span>
  </mat-toolbar>

  <form [formGroup]="formGroup" (submit)="verifyMfa()">
    <h4>Type the code sent to your email.</h4>

    <app-otp-input formControlName="code" [length]="6"></app-otp-input>
    <p *ngIf="showFieldError('code')" style="color: red; margin-top: 10px">
      Code is incomplete/incorrect/required
    </p>

    <button
      mat-raised-button
      color="accent"
      type="submit"
      [disabled]="requestingAccess || formGroup?.get('code')?.invalid"
    >
      Validate code
    </button>

    <div style="height: 100px; display: flex; align-items: center; gap: 10">
      <p *ngIf="isResendDisabled" class="timer-text">00:{{ countdown }}</p>

      <button
        mat-button
        type="button"
        [disabled]="isResendDisabled"
        (click)="resendCode()"
      >
        Resend code
      </button>
    </div>
  </form>
</div>
